export const defaultProps = {
  title: 'Join a community, with a BODi Partner',
  description:
    'Get support, for free, from a BODi Partner to keep you accountable and help you reach your goals.*',
  successLine1: 'We assigned you a BODi Partner!',
  successLine2: 'They will reach out to you shortly.',
  ctaText: 'FIND A PARTNER',
  backgroundImage: '/images/partner-module-bg.png',
  backgroundColor: '#F8FBF5',
}
